import React from 'react'

const Statelogin = () => {
  return (
    <div>
        <h2>Silahkan Login</h2>
    </div>
  )
}

export default Statelogin